<template>
  <!-- 微信代金券 weChatVoucher -->
  <div>
    <x-tabula
      ref="table"
      rowKey="couponId"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="true"
      :deleteParam="deleteParam"
    >
      <template slot="opt_h" slot-scope="{row}">
        <a-tooltip :title="row.qualifyDesc">
          <div class="feed-over-text">{{row.qualifyDesc}}</div>
        </a-tooltip>
      </template>
    </x-tabula>

    <add-model ref='add'></add-model>
    <edit-model ref='edit'></edit-model>
  </div>
</template>

<script>
import addModel from './addModel.vue';
import editModel from './editModel.vue';

export default {
  name: 'weChatVoucher',
  components: {addModel, editModel},
  data () {
    return {
      searchList: [
        {
          props: ['stockName'],
          placeholder: '名称',
          options: [],
          inputType: 'input'
        },
        {
          props: ['status'],
          placeholder: '状态',
          options: [
          ],
          inputType: 'select'
        }

      ],
      tableOptList: [
        {
          text: '新增',
          icon: 'plus',
          handle: () => { this.$refs.add.show(); },
          permi: ['community:localWxCoupon:add']
        },
        {text: '删除', icon: 'close', disabled: true, permi: ['community:localWxCoupon:delete'] }
      ],
      rowOptList: [
        {
          text: '编辑',
          handle: (row) => { this.$refs.edit.show(row.couponId); },
          rowOptDisHandle: row => (row.status == 4),
          key: '',
          permi: ['community:localWxCoupon:edit']
        },
        {
          text: '',
          handle: (row) => { this.changeStatus(row); },
          rowOptText: row => row.status === 5 ? '重启' : '暂停',
          rowOptDisHandle: row => (row.status <= 2 || row.status == 4),
          customRender: true,
          permi: ['community:localWxCoupon:switch']
        },
        {
          text: '删除',
          handle: row => this.$refs.table.showDeleteConfirm(row),
          rowOptDisHandle: row => row.canDelete == 0, // 禁用按钮
          permi: ['community:localWxCoupon:delete']
        }

      ],
      columns: [
        {
          title: '批次号',
          dataIndex: 'stockId',
          align: '',
          width: '200'
        },
        {
          title: '批次名称',
          dataIndex: 'stockName',
          align: '',
          width: '200'
        },
        {
          title: '面额',
          dataIndex: 'couponAmount',
          align: '',
          width: '200'
        },
        {
          title: '门槛',
          dataIndex: 'transactionMinimum',
          align: '',
          width: '200'
        },
        {
          title: '平台发放上限',
          dataIndex: 'publishNum',
          align: '',
          width: '200'
        },
        {
          title: '平台已发券总量',
          dataIndex: 'useNum',
          align: '',
          width: '200'
        },
        {
          title: '可用时间',
          dataIndex: 'availableTime',
          align: '',
          width: '200'
        },
        {
          title: '批次状态',
          dataIndex: 'statusDesc',
          align: '',
          width: '200'
        },

        {
          title: '操作',
          dataIndex: 'action',
          align: '',
          width: '200',
          scopedSlots: { customRender: 'action' }
        }
      ],
      dataSource: [],
      searchParams: {
        stockName: undefined,
        status: undefined
      },

      listApi: {
        url: '/pm/wx/coupon/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '/pm/wx/coupon/',
        param: { pk_key: 'couponId', pk_val: '' },
        title: '批次号',
        key: 'stockId'
      }
    };
  },

  created () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      this.$get({
        url: '/dict/data/dictType/comu_wx_coupon_status',
        params: {}
      }).then(({data}) => {
        this.searchList[1].options = data;
      });
    },
    changeStatus (row) {
      if (row.status == 5) {
        this.$put({
          url: `/pm/wx/coupon/restart/${row.couponId}`
        }).then((res) => {
          this.$message.success('操作成功！');
          this.$refs.table.getTableList();
        });
      } else {
        this.$put({
          url: `/pm/wx/coupon/stop/${row.couponId}`
        }).then((res) => {
          this.$message.success('操作成功！');
          this.$refs.table.getTableList();
        });
      }
    }
  }
};
</script>

<style scoped>
</style>
